import { createContext } from "react";
import { IRootStore } from "@workspace/types";

export const StoreContext = createContext<IRootStore | null>(
  null,
);
